export default {"src":"/_next/static/media/mention.43804470.svg","height":512,"width":513};